"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _DeleteChangesModal = _interopRequireDefault(require("./autosaving/DeleteChangesModal"));

var _SavingSpinner = _interopRequireDefault(require("./autosaving/SavingSpinner"));

var _ReadOnlyMessage = _interopRequireDefault(require("./autosaving/ReadOnlyMessage"));

var _SavedMessage = _interopRequireDefault(require("./autosaving/SavedMessage"));

var _ErrorMessage = _interopRequireDefault(require("./autosaving/ErrorMessage"));

var _AutosaveStates = require("lead-flows-ui/constants/AutosaveStates");

var SecondaryNavigationSave =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SecondaryNavigationSave, _PureComponent);
  (0, _createClass2.default)(SecondaryNavigationSave, null, [{
    key: "propTypes",
    get: function get() {
      return {
        dyno: _react.default.PropTypes.object.isRequired,
        lastSaveAt: _react.default.PropTypes.number,
        handleDeleteDraft: _react.default.PropTypes.func.isRequired,
        readOnly: _react.default.PropTypes.bool.isRequired,
        saving: _react.default.PropTypes.bool.isRequired,
        savingHasError: _react.default.PropTypes.bool.isRequired,
        savingRecentError: _react.default.PropTypes.object,
        validation: _react.default.PropTypes.object
      };
    }
  }]);

  function SecondaryNavigationSave(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SecondaryNavigationSave);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SecondaryNavigationSave).call(this, props));
    _this.state = {
      showDeleteModal: false,
      autosaveState: _this.getAutosaveState(props)
    };
    _this.handleDeleteDraft = _this.handleDeleteDraft.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeDeleteModal = _this.closeDeleteModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.openDeleteModal = _this.openDeleteModal.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SecondaryNavigationSave, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        autosaveState: this.getAutosaveState(nextProps)
      });
    }
  }, {
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.secondaryNavigation.save." + suffix;
    }
  }, {
    key: "handleDeleteDraft",
    value: function handleDeleteDraft() {
      var _this$props = this.props,
          dyno = _this$props.dyno,
          handleDeleteDraft = _this$props.handleDeleteDraft;
      handleDeleteDraft(dyno.id);
      this.setState({
        showDeleteModal: false
      });
    }
  }, {
    key: "openDeleteModal",
    value: function openDeleteModal() {
      this.setState({
        showDeleteModal: true
      });
    }
  }, {
    key: "closeDeleteModal",
    value: function closeDeleteModal() {
      this.setState({
        showDeleteModal: false
      });
    }
  }, {
    key: "renderErrorMessage",
    value: function renderErrorMessage(hasValidationErrors) {
      return _react.default.createElement(_ErrorMessage.default, {
        hasValidationErrors: Boolean(hasValidationErrors),
        savingRecentError: this.props.savingRecentError,
        lastSaveAt: this.props.lastSaveAt
      });
    }
  }, {
    key: "renderSavedMessage",
    value: function renderSavedMessage() {
      var dyno = this.props.dyno;
      return _react.default.createElement(_SavedMessage.default, {
        dyno: dyno,
        onDeleteDraft: this.openDeleteModal
      });
    }
  }, {
    key: "getAutosaveState",
    value: function getAutosaveState(props) {
      var _props$dyno = props.dyno,
          draft = _props$dyno.draft,
          changes = _props$dyno.changes,
          saving = props.saving,
          savingHasError = props.savingHasError,
          validation = props.validation,
          readOnly = props.readOnly;
      var hasValidationErrors = Boolean(Object.keys(validation).length > 0);
      var hasChanges = Array.isArray(changes) && changes.length > 0;
      var state;

      if (saving) {
        state = _AutosaveStates.SAVING;
      } else if (readOnly) {
        state = _AutosaveStates.READ_ONLY;
      } else if (savingHasError) {
        state = _AutosaveStates.SAVE_ERROR;
      } else if (hasValidationErrors) {
        state = _AutosaveStates.VALIDATION_ERROR;
      } else if (draft && hasChanges) {
        state = _AutosaveStates.SAVE_SUCESS;
      } else {
        state = _AutosaveStates.PRISTINE;
      }

      return state;
    }
  }, {
    key: "renderSavingContent",
    value: function renderSavingContent() {
      var autosaveState = this.state.autosaveState;

      switch (autosaveState) {
        case _AutosaveStates.SAVING:
          return _react.default.createElement(_SavingSpinner.default, null);

        case _AutosaveStates.READ_ONLY:
          return _react.default.createElement(_ReadOnlyMessage.default, null);

        case _AutosaveStates.SAVE_ERROR:
          return this.renderErrorMessage(true);

        case _AutosaveStates.VALIDATION_ERROR:
          return this.renderErrorMessage(true);

        case _AutosaveStates.SAVE_SUCESS:
          return this.renderSavedMessage();

        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var showDeleteModal = this.state.showDeleteModal;
      return _react.default.createElement("div", {
        className: "secondary-navigation-saving text-right"
      }, _react.default.createElement("div", {
        className: "secondary-navigation-saving__info"
      }, this.renderSavingContent(), _react.default.createElement(_DeleteChangesModal.default, {
        show: showDeleteModal,
        onConfirm: this.handleDeleteDraft,
        onCancel: this.closeDeleteModal
      })));
    }
  }]);
  return SecondaryNavigationSave;
}(_react.PureComponent);

exports.default = SecondaryNavigationSave;
module.exports = exports.default;